// Compare the selected file's metadata; timestamps alone are not a change log.
export function fileRevision(file) {
  if (!file) return null;
  return { name: file.name, size: file.size, lastModified: file.lastModified };
}
export function sameFileRevision(a, b) {
  return Boolean(
    a &&
    b &&
    Number.isFinite(a.lastModified) &&
    Number.isFinite(b.lastModified) &&
    a.name === b.name &&
    a.size === b.size &&
    a.lastModified === b.lastModified
  );
}
export function sameQrsRevision(a, b) {
  return Boolean(
    a &&
    b &&
    sameFileRevision(a.main, b.main) &&
    ['a', 'b'].every((role) => (!a[role] && !b[role]) || sameFileRevision(a[role], b[role]))
  );
}
